import { Outlet } from 'react-router-dom'

const PublicLayout = () => {
    return (
        <div className="w-full h-screen bg-gradient-login">
            <Outlet />
        </div>
    )
}

export default PublicLayout
